{
  "markread": "Mindet olvastam",
  "newest": "Legfrissebb",
  "unread": "Olvasatlan",
  "starred": "Megjelölt",
  "tags": "Címkék",
  "alltags": "Összes címke",
  "timestamp": "{0,date} {0,time}",
  "hours": "{0,plural,one {1 órája},other {# órája}}",
  "minutes": "{0,plural,one {1 perce},other {# perce}}",
  "seconds": "{0,plural,one {1 másodperce},other {# másodperce}}",
  "star": "Megjelölt",
  "unstar": "Jelöletlen",
  "mark": "Olvasott",
  "unmark": "Olvasatlan",
  "load_img": "Képbetöltés",
  "open_window": "Megnyitás",
  "searchbutton": "Keresés",
  "sources": "Hírforrások",
  "source_add": "Új hírforrás",
  "source_opml": "OPML-fájl importálása",
  "source_export": "Hírforrások exportálása",
  "source_edit": "Módosítás",
  "source_delete": "Törlés",
  "source_warn": "Biztos törölhető a hírforrás?",
  "source_new": "Új hírforrás",
  "source_title": "Cím",
  "source_tags": "Címkék",
  "source_comma": "(vesszővel tagolva)",
  "source_select": "A típus kiválasztása",
  "source_type": "Típus",
  "source_save": "Mentés",
  "source_cancel": "Mégsem",
  "source_saved": "Mentve",
  "no_entries": "Nincs megjeleníthető hír.",
  "more": "Továbbiak",
  "login": "Bejelentkezés",
  "login_username": "Felhasználónév",
  "login_password": "Jelszó",
  "no_title": "Nincs cím",
  "filter": "Szűrő",
  "online_count": "A kiszolgálón lévő hírek száma",
  "offline_count": "A helyben tárolt hírek száma",
  "error_session_expired": "A munkamenet lejárt.",
  "app_reload": "Újratöltés",
  "sources_refreshed": "Az új hírek keresése kész.",
  "reload_list": "Újratöltés",
  "error_unwritable_logs": "A napló nem írható.",
  "error": "Hiba történt",
  "source_pwd_placeholder": "Változatlan",
  "source_filter": "Szűrő",
  "loginbutton": "Bejelentkezés",
  "logoutbutton": "Kijelentkezés",
  "close_entry": "Bezárás",
  "share_native_label": "Megosztás",
  "error_load_tags": "Nem sikerült betölteni a címkéket:",
  "searchremove": "Keresőpanel elrejtése",
  "next": "Következő",
  "app_update": "A selfoss frissítve lett, újra kell tölteni az oldalt.",
  "error_offline_storage": "Tárolóhiba kapcsolat nélküli módban: {0}. Az újratöltés segíthet. A kapcsolat nélküli mód mostantól ki van kapcsolva.",
  "error_star_item": "Nem sikerült módosítani a hír megjelöltségét:",
  "days": "{0,plural,zero {ma},one {tegnap},other {# napja}}",
  "share_twitter_label": "Twitter-megosztás",
  "share_mail_label": "Megosztás e-mailben",
  "settingsbutton": "Beállítások",
  "sources_loading": "Hírforrások betöltése…",
  "tag_change_color_button_title": "Szín cseréje",
  "entries_loading": "Betöltés…",
  "login_invalid_credentials": "Hibás felhasználónév vagy jelszó",
  "login_error_generic": "Sikertelen bejelentkezés: {errorMessage}",
  "login_offline": "Kapcsolat nélküli tároló",
  "experimental": "Kísérleti funkció",
  "error_saving_color": "Nem sikerült menteni az új színt:",
  "error_sync": "Nem sikerült szinkronizálni a kiszolgálóval:",
  "error_configuration": "Nem sikerült beolvasni a beállításokat.",
  "error_share_native_abort": "Nem sikerült megosztani a hírt – vagy nincsenek megosztási célok, vagy a művelet törölve lett.",
  "error_refreshing_source": "Nem sikerült új híreket keresni:",
  "info_url_copied": "Az URL a vágólapra lett másolva.",
  "article_actions": "Műveletek",
  "article_reading_time": "~{0} perc",
  "share_diaspora_label": "Diaspora-megosztás",
  "share_facebook_label": "Facebook-megosztás",
  "offline_navigation_unavailable": "A címkék és hírforrások módosítása kapcsolat nélküli módban jelenleg nem támogatott.",
  "source_last_post": "Legutóbbi hír",
  "source_refresh": "Új hírek keresése",
  "source_go_to_settings": "Beállítások",
  "sources_leaving_unsaved_prompt": "Nem minden változás lett elmentve. Biztos bezárható beállítófelület?",
  "error_share_native": "Nem sikerült megosztani a hírt.",
  "share_mastodon_label": "Mastodon-megosztás",
  "share_pocket_label": "Pocket-mentés",
  "share_wallabag_label": "Wallabag-mentés",
  "share_wordpress_label": "WordPress-megosztás",
  "share_copy_label": "Hivatkozás másolása",
  "search_label": "Keresőkifejezés",
  "refreshbutton": "Új hírek keresése",
  "no_sources": "Nincsenek megadva hírforrások.",
  "source_menu": "További műveletek",
  "source_browse": "Megtekintés",
  "source_deleting": "A hírforrás törlése…",
  "source_warn_cancel_dirty": "Bezárás mentés nélkül?",
  "source_autotitle_hint": "Üresen hagyva automatikus kitöltés",
  "source_params_loading": "Paraméterek betöltése…",
  "source_saving": "A változások mentése…",
  "login_in_progress": "Bejelentkezés…",
  "error_unauthorized": "A folytatáshoz {link_begin}bejelentkezés{link_end} szükséges.",
  "error_check_log_file": "Hiba történt, részletek a naplófájlban: „{0}”.",
  "error_check_system_logs": "Hiba történt, részletek a rendszernaplóban.",
  "streamerror": "Nem töltődött le hír. Újratöltés?",
  "error_add_source": "Nem sikerült hozzáadni a hírforrást:",
  "error_edit_source": "Nem sikerült menteni a hírforrás változásait:",
  "error_delete_source": "Nem sikerült törölni a hírforrást:",
  "error_mark_items": "Nem sikerült olvasottra állítani a megjelenített híreket:",
  "error_unknown_tag": "Ismeretlen címke:",
  "error_unknown_source": "Ismeretlen hírforrás-azonosító:",
  "error_mark_item": "Nem sikerült módosítani a hír olvasottságát:",
  "error_logout": "Nem sikerült kijelentkezni:",
  "error_loading": "Betöltési hiba:",
  "error_loading_stats": "Nem sikerült betölteni a böngészési statisztikát:",
  "error_offline_storage_not_available": "Nem áll rendelkezésre tároló a kapcsolat nélküli módhoz. Ellenőrizni kell, hogy a böngésző támogatja-e az {0}IndexedDB API{1}-t, illetve Google Chrome alapú böngészőben a selfoss nem használható inkognitó módban.",
  "error_invalid_subsection": "Érvénytelen aloldal:"
}
